/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type UserSetCurrentBrandMutationInput = {
    brandId: string;
    clientMutationId?: string | null | undefined;
};
export type ChangeCurrentBrandMutationVariables = {
    input: UserSetCurrentBrandMutationInput;
};
export type ChangeCurrentBrandMutationResponse = {
    readonly setUserCurrentBrand: {
        readonly user: {
            readonly id: string;
        } | null;
    } | null;
};
export type ChangeCurrentBrandMutation = {
    readonly response: ChangeCurrentBrandMutationResponse;
    readonly variables: ChangeCurrentBrandMutationVariables;
};



/*
mutation ChangeCurrentBrandMutation(
  $input: UserSetCurrentBrandMutationInput!
) {
  setUserCurrentBrand(input: $input) {
    user {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UserSetCurrentBrandMutationPayload",
    "kind": "LinkedField",
    "name": "setUserCurrentBrand",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChangeCurrentBrandMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChangeCurrentBrandMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5f7a3305c41f585fb955ba794ff8d995",
    "id": null,
    "metadata": {},
    "name": "ChangeCurrentBrandMutation",
    "operationKind": "mutation",
    "text": "mutation ChangeCurrentBrandMutation(\n  $input: UserSetCurrentBrandMutationInput!\n) {\n  setUserCurrentBrand(input: $input) {\n    user {\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '02e04467bcfe6d7638a223351a17fe8e';
export default node;
